import React from 'react';
import styled from 'styled-components';

import { Arrow } from '../icons';

const BackButtonContainer = styled.span`
  display: flex;
  align-items: center;
  padding: 15px;
  cursor: pointer;

  overflow: hidden;

  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.2px;
  color: white;

  svg {
    margin-right: 14px;
  }
`;

type Props = {
  text: string
}

const BackButton = ({ text }: Props) => {
  return (
    <BackButtonContainer>
      <Arrow direction='left' />
      { text }
    </BackButtonContainer>
  );
};

export default BackButton;